// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import UserSelect2 from "src/components/user/SelectInvite";
import { FormControl, FormLabel } from "@chakra-ui/react";

import type { NewUser } from "src/types";

type Props = {
  owner: ?NewUser,
  handleOwner: Function
};

const Owner = ({ owner, handleOwner }: Props) => (
  <FormControl px={4}>
    <FormLabel>{i18n.t(k.OWNER)}</FormLabel>
    <UserSelect2 value={owner} handleChange={handleOwner} />
  </FormControl>
);

export default Owner;
